/**
 * Het gesprek waarmee Decca een opzet voor een inzicht schrijft.
 *
 * Het inzicht-id reist in contextData; de server-tools lezen het dáár
 * (get_insight_brief) en zetten het in de kaart (save_insight_text). Het
 * model krijgt alleen de opdracht; de cijfers en schrijfregels haalt het zelf
 * op, zodat ze niet in de frontend gespiegeld hoeven te worden.
 * AI-CONTEXT: See docs/features/intelligence-decca-opzet.md
 *
 * @param {{insight: {ID: string, Text?: string}, themeTitle: string}} args
 * @returns {{subject: string, title: string, welcomeMessage: string, contextData: object}}
 */
const buildInsightDraftBrief = ({ insight, themeTitle }) => ({
    subject: 'InsightTextCuration',
    title: `Opzet inzicht: ${themeTitle}`,
    welcomeMessage: `Ik kan een eerste opzet schrijven voor het inzicht "${themeTitle}". Ik haal de cijfers van de cel en de interviewcitaten op, schrijf de tekst hier in de chat, en zet hem na jouw akkoord in het tekstvak van het inzicht. Zeg maar: "maak een opzet".`,
    contextData: {
        insightId: insight.ID,
        themeTitle,
        hasText: !!(insight.Text && insight.Text.trim()),
        instructions: 'Dit gesprek gaat over één inzicht van Impact Intelligence (Deccos-beheer). Werkwijze: (1) roep get_insight_brief aan voor de gegevens en de schrijfregels; (2) schrijf de opzet in de chat volgens die regels; (3) vraag of de gebruiker akkoord is; (4) pas na akkoord roep je save_insight_text aan met de volledige tekst — de gebruiker bevestigt daarna nog via een kaart. Gebruik geen andere tools.',
    },
})

export default buildInsightDraftBrief
